import { ModelInstance, BaseModel, ToBackHook, ToFrontHook } from './util';
import { HandballStatistic } from './handball-statistic';
import { GameTeamStatisticBase } from './game-team-statistic-base';

@ModelInstance({
  mappingFields: {
    team: 'team',
    competitor_team: 'competitorTeam'
  },
  relation: {
    team: HandballStatistic,
    competitorTeam: HandballStatistic
  }
})
export class HandballGameTeamStatistic extends BaseModel implements GameTeamStatisticBase {
  team: HandballStatistic;
  competitorTeam: HandballStatistic;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
